
























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { KonvaEventObject } from 'konva/types/Node';
import mapLabels from '../data/mapLabels';

@Component
export default class MapCanvas extends Vue {
  @Prop({ type: Object }) readonly center!: { x: number; y: number };
  mapLabels = mapLabels;

  get configLabels() {
    return {
      x: -this.center.x / 40,
      y: -this.center.y / 40,
    };
  }

  addHighlight({ target }: KonvaEventObject<MouseEvent>): void {
    const container = target.getStage()?.container();
    if (container) container.style.cursor = 'pointer';
    target.to({
      opacity: 1,
      offsetY: 8,
      duration: 0.2,
    });
  }

  removeHighlight({ target }: KonvaEventObject<MouseEvent>): void {
    const container = target.getStage()?.container();
    if (container) container.style.cursor = 'default';
    target.to({ opacity: 0, offsetY: 0, duration: 0.5 });
  }

  getXOffset(x: number): number {
    const centerX = this.center.x;
    return (centerX - x) / 40;
  }

  getYOffset(y: number): number {
    const centerY = this.center.y;
    return (centerY - y) / 40;
  }
}
